 <div class="modal fade star-webportal" *ngFor="let data of modalItems;let i = index" id="dynamicModal{{i}}" tabindex="-1" role="dialog"
      aria-labelledby="exampleModalLabel" aria-hidden="true">
   <div class="modal-dialog" role="document" style="display:table;max-height:100%;top:200px;">
     <div class="modal-content" [ngStyle]="{'width':data.widthOfDialog}">
       <div class="popup-header " *ngIf="!data.hideHeader">
         <h5 class="modal-title" id="exampleModalLabel" style="float:left;font-weight: 400;width:90%">{{data.titleOfDialog}}</h5>
         <button title="close" (mousedown)="closeModalDialog()">X</button>
       </div>
       <div class="modal-body" [ngStyle]="{'border': '1px solid #000','display':data.displayStyle,'height':data.height,'overflow-y':'auto','overflow-x':'hidden'}">
         <ng-template modal-host></ng-template>
       </div>
     </div>
   </div>
 </div>
